import { useTranslation } from 'react-i18next'

import { IconSpinner } from '../../Icon'
import Text from '../../Text'

function LoaderListItemContent({ hasText }) {
  const { t } = useTranslation()

  return (
    <>
      <IconSpinner />
      {hasText ? <Text isSecondary>{t('Select.LoaderTextKey')}</Text> : null}
    </>
  )
}

export default LoaderListItemContent
